import React from 'react';

const Bank: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_539_141)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9998 0.741669L39.7498 11.275V17.25H0.249756V11.275L19.9998 0.741669ZM2.24976 12.475V15.25H37.7498V12.475L19.9998 3.00834L2.24976 12.475Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.99976 19V34.75H3.99976V19H5.99976Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.9998 19V34.75H23.9998V19H25.9998Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9998 19V34.75H13.9998V19H15.9998Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.9998 19V34.75H33.9998V19H35.9998Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9998 8.5C19.1713 8.5 18.4998 9.17157 18.4998 10C18.4998 10.8284 19.1713 11.5 19.9998 11.5C20.8282 11.5 21.4998 10.8284 21.4998 10C21.4998 9.17157 20.8282 8.5 19.9998 8.5ZM16.4998 10C16.4998 8.067 18.0668 6.5 19.9998 6.5C21.9328 6.5 23.4998 8.067 23.4998 10C23.4998 11.933 21.9328 13.5 19.9998 13.5C18.0668 13.5 16.4998 11.933 16.4998 10Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.249756 32.75H39.7498V39.75H0.249756V32.75ZM2.24976 34.75V37.75H37.7498V34.75H2.24976Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_539_141">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(-0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bank;
